import { createSlice } from '@reduxjs/toolkit';

export interface AcquisitionSchedule {
  contractExecution: string;
  dueDiligenceEnds: string;
  settlement: string;
}

const initialState: AcquisitionSchedule = {
  contractExecution: '',
  dueDiligenceEnds: '',
  settlement: '',
};

export const AcquisitionScheduleSlice = createSlice({
  name: 'acquisitionScheduleSliceInfo',
  initialState,
  reducers: {
    setAcquisitionSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setAcquisitionSchedule } = AcquisitionScheduleSlice.actions;

export default AcquisitionScheduleSlice.reducer;
